import React, { useState, useEffect, memo } from "react";
import CardRubros from "./cardRubros";
import { flattenRubrosHierarchy } from "../desplegableRubrosPadres";
import { Theme, useMediaQuery, useTheme } from "@mui/material";
import { ExpandMore } from "@mui/icons-material";
import {
  RichTreeView,
  SimpleTreeView,
  TreeItem,
  TreeItem2,
} from "@mui/x-tree-view";
import { IRubro } from "../../../AdminProducts/types/producto";

interface MultiSelectTreeViewProps {
  searchedRubro?: string | null; // Prop para recibir el rubro buscado
  rubros: any[];
  updateRubros: () => void;
  expandedNodes: string[];
  setExpandedNodes: (nodes: string[]) => void;
}

const MultiSelectTreeView: React.FC<MultiSelectTreeViewProps> = ({
  searchedRubro,
  rubros,
  updateRubros,
  expandedNodes,
  setExpandedNodes,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [matched, setMatched] = useState<string[]>([]);

  const handleNodeSelect = (nodeId: any) => {
    const rubro = flattenRubrosHierarchy(rubros).find(
      (r) => r.idrubro === parseInt(nodeId)
    );
    const rubroPadreId: number | undefined = rubro?.idrubroPadre;

    let expanded = [...expandedNodes];

    if (expandedNodes.includes(nodeId.toString())) {
      expanded = expanded.filter((id) => id !== nodeId.toString());
      rubro?.rubros?.map((r: IRubro) => {
        if (expanded.includes(r.idrubro.toString())) {
          expanded = expanded.filter((id) => id !== r.idrubro.toString());
        }
      });
    } else {
      expanded.push(nodeId.toString());
    }

    setExpandedNodes([...expanded]);
  };

  useEffect(() => {
    if (searchedRubro && rubros.length > 0) {
      const found = findMatchingRubros(rubros, searchedRubro);
      setMatched(found);
    } else {
      setMatched([]);
    }
  }, [searchedRubro, rubros]);

  const findMatchingRubros = (
    nodes: IRubro[],
    rubroToFind: string
  ): string[] => {
    const matched: string[] = [];
    for (const node of nodes) {
      if (node.nombre.toLowerCase().includes(rubroToFind.toLowerCase())) {
        matched.push(node.idrubro.toString());
      }
      if (node.rubros) {
        const foundInChildren = findMatchingRubros(node.rubros, rubroToFind);
        matched.push(...foundInChildren);
      }
    }
    return matched;
  };

  const renderTreeItems = (nodes: IRubro[]) =>
    nodes.map((node: IRubro) => {
      const isNodeMatched = matched.includes(node.idrubro.toString());
      return (
        <TreeItem
          key={node.idrubro}
          itemId={node.idrubro.toString()}
          label={
            <div
              //className={`${nodeClasses.nombre}`}
              style={{
                backgroundColor: isNodeMatched ? "yellow" : "transparent",
                ...(isNodeMatched && { fontStyle: "italic" }),
              }}
            >
              {node.nombre}
            </div>
          }
          onClick={() => handleNodeSelect(node.idrubro)}
        >
          {expandedNodes.includes(node.idrubro.toString()) && (
            <CardRubros
              rubros={rubros}
              isMobile={isMobile}
              //classes={classes}
              rubro={node}
              updateRubros={updateRubros}
              handleNodeSelect={handleNodeSelect}
            />
          )}
          {node.rubros && renderTreeItems(node.rubros)}
        </TreeItem>
      );
    });

  return (
    <>
      {rubros.length > 0 && (
        <div style={{ marginLeft: "-22px" }}>
          <SimpleTreeView
            key={JSON.stringify(rubros)}
            //getItemId={(item) => item.idrubro.toString()}
            //getItemLabel={(item) => item.nombre}
            //defaultCollapseIcon={<ExpandMore />}
            //defaultExpandIcon={<ChevronRightIcon />}
            //expanded={expandedNodes}
            expandedItems={expandedNodes}
            //items={rubros}
            children={renderTreeItems(rubros)}
            style={{ height: 1000, flexGrow: 1, maxWidth: 1000 }}
          />
        </div>
      )}
    </>
  );
};

export default MultiSelectTreeView;
